module.exports = __webpack_public_path__ + "84034dd9f33c5e9a539a51536c77ae4f.png";